/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvo.defs'
export { main as default } from './getConvo.defs'
